import React from "react";
import Logo from "../Assets/img/LogoMMA.png";
import { FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { Link } from "react-router-dom";

function AppFooter() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="gap-x-8 grid grid-cols-1 tab-port:grid-cols-5 layout-margin">
          <div className="mt-2 flex">
            <div className="footer__logo-box">
              <img
                className="footer__logo"
                src={Logo}
                alt="Logo Ministerio de Medio Ambiente"
              />
            </div>
            <div className="border-r border-white-100 hidden tab-port:block"></div>
          </div>
          <div className="justify-self-auto tab-port:justify-self-center mt-16 tab-port:mt-2">
            <div className="">
              <div className="footer__title">Ayuda</div>
              <ul className="footer__list" style={{ fontWeight: "300" }}>
                <Link to={"terminos"}>
                  <li className="my-4">Términos de Uso</li>
                </Link>
                <Link to={"politicas"}>
                  <li className="my-4">Políticas de Privacidad</li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="justify-self-auto tab-port:justify-self-center mt-16 tab-port:mt-2">
            <div className="">
              <div className="footer__title">Información</div>
              <ul className="footer__list" style={{ fontWeight: "300" }}>
                <li className="my-4">
                  <a href="https://ambiente.gob.do/">
                    Ministerio de Medio Ambiente y Recursos Naturales
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="justify-self-auto tab-port:justify-self-center mt-16 tab-port:mt-2">
            <div className="">
              <div className="footer__title">Llámanos</div>
              <ul className="footer__list" style={{ fontWeight: "300" }}>
                <li className="my-4">Central: (809)-567-4300</li>
              </ul>
            </div>
          </div>
          <div className="justify-self-auto tab-port:justify-self-center mt-16 tab-port:mt-2">
            <div className="">
              <div className="footer__title">Ubicación</div>
              <ul className="footer__list" style={{ fontWeight: "300" }}>
                <li className="my-4">
                  Avenida Cayetano Germosén esq. Avenida Gregorio Luperón,
                  Ensanche El Pedregal, Santo Domingo, R.D.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__trademark grid grid-cols-1 tab-port:grid-cols-[3.5fr_1fr] ">
        <div className="footer__trademark-copyright px-20">
          © 2022 Todos los Derechos Reservados.
        </div>
        <div className="footer__trademark-social">
          <span>SÍGUENOS</span>
          <ul className="footer__trademark-social-list">
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.facebook.com/AmbienteRD/">
                  <FaFacebookF />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://twitter.com/ambienterd">
                  <FaTwitter />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.instagram.com/ambienterd/">
                  <RiInstagramFill />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.youtube.com/c/ministerioambienterd">
                  <FaYoutube />
                </a>
              </i>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
